import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { GlobalMessageService, GlobalMessageType, OccEndpointsService } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { CoreLookUpService } from 'src/app/services/feature/kb-my-cores/kbMyCores.service';

@Component({
  selector: 'app-KbCoreReports',
  templateUrl: './KbCoreReports.component.html',
  styleUrls: ['./KbCoreReports.component.scss'],
  standalone: false
})
export class KbCoreReportsComponent implements OnInit {
  screenWidth: number;
  widthPercentage = 67;
  isMobile: boolean = false;

  getApi$: Observable<any> = this.serviceEnd.getApiCoreReports();
  searchInput: any;
  showChild: boolean = false;
  selectedCustomerID: any;
  month: any;
  fileformat: any;
  baseUrl: string;
  fileCards: any;
  platformId = inject(PLATFORM_ID);
  subscription = new Subscription();
  constructor(
    private breakpointObserver: BreakpointObserver,
    private cdr: ChangeDetectorRef,
    private endPointService: OccEndpointsService,
    private serviceEnd: CoreLookUpService,
    private globalMsg: GlobalMessageService
  ) {
    this.subscription.add(this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small])
      .subscribe((result) => {
        this.isMobile = result.matches;
        if (this.isMobile) {
          this.widthPercentage = 87;
        }
      }));
    this.baseUrl = this.endPointService.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
  }
  setCustomWidth() {
    if (isPlatformBrowser(this.platformId)) {
      const widthInPixels = (this.screenWidth * this.widthPercentage) / 100;
      document.documentElement.style.setProperty('--custom-width', `${widthInPixels}px`);
    }
  }
  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.screenWidth = window.innerWidth;
    }
    this.setCustomWidth();
  }
  fileselecttype(event: any) {
    this.fileformat = event;
  }
  monthselectyear(event: any) {
    this.month = event;
  }
  selectedsoldTo(data: any) {
    this.showChild = false;
    this.selectedCustomerID = data;
  }
  postApiCall(custId: any, month: any, filetype: any) {
    const customerId = this.selectedCustomerID?.sapCustomerID ?? custId?.sapCustomerID;
    const reqDate = this.month ?? month.key;
    const fileFormat = this.fileformat ?? filetype;
    const payLoad = {
      b2bUnitsUid: customerId,
      requestedDate: reqDate,
      format: fileFormat
    }
    this.subscription.add(this.serviceEnd.postApiCoreReports(payLoad).subscribe((data: any) => {
      this.fileCards = data?.csvUrls?.entry;
      const isEmpty = (obj: any): boolean => Object.keys(obj).length === 0;
      const isCsvUrlsEmpty = isEmpty(data?.csvUrls);
      if (isCsvUrlsEmpty) {
        const key = 'common.text_account_core_search_noRequestFound';
        this.globalMsg.add({ key: key }, GlobalMessageType.MSG_TYPE_ERROR);
      }

      this.cdr.detectChanges();
    }));
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }

}


